import React, { useEffect, useMemo, useRef, useState } from 'react';
import CardCommon from '../CardCommon';
import { Segment } from 'tea-component';
import useLanguage from '@op/hooks/useLanguage';
import { useHeroOpinionSummary } from '@op/pages/Hero/hook/useHeroOpinionSummary';
import { mdContentToHtml, replaceGptText } from '@op/utils/text';
import { COMMENTS_SELECTOR, CommentsToggle, useCommentsToggleSimple } from '@op/components/GPT/components/CommentsToggle';
import '../GPT/components/GptCardView.scss';

const segmentOptions = [
  { text: 'Global', value: 'global' },
  { text: 'Southeast Asia', value: 'sea' },
];

export default function GptPanelItem({
  filter,
}: {
  filter: any;
}) {
  const { isEn, formatOptionsMessage } = useLanguage();
  const [area, setArea] = useState('global');
  const { showComments, setShowComments, hideClassName } = useCommentsToggleSimple(false);
  const [hasComments, setHasComments] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  const filterParams = useMemo(() => {
    if (!filter) return undefined;
    const { keyword_en } = filter || {};

    return {
      ...filter,
      hero: keyword_en?.[0] || '',
      area_type: area,
      // view_mode: 'summary',
    };
  }, [filter, area]);

  const { reportCn, reportEn, loading } = useHeroOpinionSummary(filterParams);

  const reportText = isEn ? reportEn : reportCn;
  const isEmpty = !reportText && !loading;

  const reportHtml = useMemo(() => {
    if (!reportText) return null;
    const replacedText = replaceGptText(reportText);
    const { html } = mdContentToHtml(replacedText);
    return html;
  }, [reportText]);

  // DOM 检测：渲染后检测是否存在评论元素
  useEffect(() => {
    if (!isEmpty && reportHtml && contentRef.current) {
      setHasComments(!!contentRef.current.querySelector(COMMENTS_SELECTOR));
    } else {
      setHasComments(false);
    }
  }, [reportHtml, isEmpty]);

  return (
    <CardCommon
      contentCard
      loading={loading}
      empty={isEmpty}
      emptyHeight={350}
      loadingHeight={350}
      className='dbo-gpt-panel-item'
      // operations={reportHtml ? [copyIcon] : []}
      // handleOperationsOnClick={({ symbol }) => {
      //   if (symbol === 'copy') {
      //     const div = document.createElement('div');
      //     div.innerHTML = reportHtml || '';
      //     DBO_T.copy(div, formatMessage);
      //   }
      // }}
      subTitle={(
        <>
          <Segment
            options={formatOptionsMessage(segmentOptions)}
            value={area}
            onChange={(value) => setArea(value)}
            className='segment-light'
          />
          {hasComments && (
            <CommentsToggle
              checked={showComments}
              onChange={(value) => setShowComments(value)}
            />
          )}
        </>
      )}
    >
      {reportHtml && (
        <div
          ref={contentRef}
          className={hideClassName}
          dangerouslySetInnerHTML={{ __html: reportHtml }}
        />
      )}
    </CardCommon>
  );
}
